import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:'linear-gradient(135deg,#1E2A38 0%,#2E4057 100%)'
    }}>
      <div style={{
        background:'#fff', borderRadius:16, padding:'48px 40px',
        width:'100%', maxWidth:400, boxShadow:'0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ fontSize:48, marginBottom:8 }}>💰</div>
          <h1 style={{ margin:0, fontSize:24, color:'#1E2A38', fontWeight:700 }}>Budget Tracker</h1>
          <p style={{ margin:'8px 0 0', color:'#888', fontSize:14 }}>Personal Finance — AA Experts</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom:16 }}>
            <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#444', marginBottom:6 }}>
              Username
            </label>
            <input
              type="text" value={username} onChange={e=>setUsername(e.target.value)}
              required autoFocus
              style={{ width:'100%', padding:'10px 14px', borderRadius:8, border:'1.5px solid #ddd',
                       fontSize:14, boxSizing:'border-box', outline:'none' }}
              placeholder="Enter username"
            />
          </div>
          <div style={{ marginBottom:24 }}>
            <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#444', marginBottom:6 }}>
              Password
            </label>
            <input
              type="password" value={password} onChange={e=>setPassword(e.target.value)}
              required
              style={{ width:'100%', padding:'10px 14px', borderRadius:8, border:'1.5px solid #ddd',
                       fontSize:14, boxSizing:'border-box', outline:'none' }}
              placeholder="Enter password"
            />
          </div>
          <button
            type="submit" disabled={loading}
            style={{
              width:'100%', padding:'12px', borderRadius:8, border:'none',
              background: loading ? '#aaa' : 'linear-gradient(135deg,#1E2A38,#2E4057)',
              color:'#fff', fontSize:15, fontWeight:700, cursor: loading?'not-allowed':'pointer'
            }}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
